import styled from "styled-components";

import { adminTokens } from "@pages/AdminDashboard/theme/adminTokens";
import { StatusBadge, Tag } from "@pages/AdminDashboard/ui/StatusBadge";
import { UiKitSection } from "@pages/AdminDashboard/ui/UiKitSection";

interface LookExample {
  name: string;
  statuses: string[];
}

// Every value the design's Status badges rule lists, by the look's name, then
// a value no look knows (BADGE-R11).
const lookExamples: LookExample[] = [
  { name: "Processing", statuses: ["new", "in_progress", "created", "assigned", "processing"] },
  { name: "Moving", statuses: ["out_for_delivery"] },
  { name: "Done", statuses: ["completed"] },
  { name: "Needs attention", statuses: ["waiting", "support", "Not yet sent", "Not sent"] },
  { name: "Error", statuses: ["error"] },
  { name: "Inactive", statuses: ["cancelled"] },
  { name: "Unknown value", statuses: ["on_hold"] },
];

const [spaceXs, spaceSm, spaceMd, , spaceXl] = adminTokens.spacing;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(240px, 100%), 1fr));
  gap: ${spaceMd}px;
  margin-bottom: ${spaceXl}px;
`;

const Example = styled.div.attrs({ role: "group" })`
  display: flex;
  flex-direction: column;
  gap: ${spaceXs}px;
  border: 1px solid ${adminTokens.color.border};
  border-radius: ${adminTokens.radius.row}px;
  padding: ${spaceMd}px;
`;

const Caption = styled.span`
  color: ${adminTokens.color.inkSoft};
  font-family: ${adminTokens.typeScale.meta.fontFamily};
  font-size: ${adminTokens.typeScale.meta.fontSize};
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceSm}px;
`;

export const StatusBadgeSection = () => (
  <UiKitSection title="Status badge">
    <Grid>
      {lookExamples.map(({ name, statuses }) => (
        <Example key={name} aria-label={name}>
          <Caption>{name}</Caption>
          <Row>
            {statuses.map((status) => (
              <StatusBadge key={status} status={status} />
            ))}
          </Row>
        </Example>
      ))}
      <Example aria-label="Tag">
        <Caption>Tag</Caption>
        <Row>
          <Tag>Current</Tag>
          <Tag>Reship</Tag>
          <Tag>ADMIN</Tag>
        </Row>
      </Example>
    </Grid>
  </UiKitSection>
);
